import apiVersion from '../_helpers/api-version';
import axiosInstance from '../_helpers/axiosConfig';
import { store } from '../_helpers/store';
import { authHeader } from '../_helpers/auth-header'

export const carePlanService = {
  save,
  clearDraft,
  saveFavorite,
  updateFavorite,
  retrieveFavorites,
}

function updateFavorite(id, carePlan) {
  return axiosInstance.request({
    method: 'PATCH',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/favorite-care-plan/${id}`,
    data: {
      physicalExam: carePlan.physicalExam,
      imaging: carePlan.imaging,
      diagnosis: carePlan.diagnosis,
      carePlan: carePlan.carePlan
    }
  }).then((response) => {
    if (response.data) {
      return response.data;
    }
  });
}

function saveFavorite(name, carePlan) {
  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/favorite-care-plan`,
    data: {
      name: name,
      physicalExam: carePlan.physicalExam,
      imaging: carePlan.imaging,
      diagnosis: carePlan.diagnosis,
      carePlan: carePlan.carePlan
    }
  }).then((response) => {
    if (response.data) {
      return response.data;
    }
  });
}

function retrieveFavorites() {
  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/favorite-care-plan`,
  }).then((response) => {
    if (response.data) {
      return response.data;
    }
  });
}

function clearDraft(telehealth) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'DELETE',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/telehealth/${telehealth.id}/care-plan`,
  });
}

function save(telehealth, carePlan, files = [], publish = false) {
  const clientId = store.getState().client.id;

  const formData = new FormData();

  files.forEach(file => formData.append('attachments[]', file, file.name));

  formData.append('physicalExam', carePlan.physicalExam);
  formData.append('imaging', carePlan.imaging);
  formData.append('diagnosis', carePlan.diagnosis);
  formData.append('carePlan', carePlan.carePlan);
  formData.append('publish', publish);

  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/telehealth/${telehealth.id}/care-plan`,
    data: formData
  }).then((response) => {
    return response.data;
  })
}